// DS: CO1.4
import React, { Suspense, lazy } from 'react';
import { useTranslation } from 'react-i18next';
import { Url, USER_PROFILE_SECTION_PATHS } from '@wix/da-url';
import { ReferralType } from '@wix/da-bi/pkg/constants';
import ConditionalWrapper from '@wix/da-shared-react/pkg/ConditionalWrapper';
import WidgetBox, { Props as WidgetBoxProps } from '../_partials/WidgetBox';
import WidgetPaywall from '../_partials/paywalls/WidgetPaywall';
import ChunkLoadingPopover from '../_partials/ChunkLoadingPopover';
import BadgesSpotlight from './BadgesSpotlight';

const BadgesSpotlightModal = lazy(
  () => import(/* webpackChunkName: "owner" */ './BadgesSpotlightModal')
);

export interface Props extends WidgetBoxProps {
  isCurrentUserCoreMember: boolean;
}

const BadgesSpotlightBox: React.FC<Props> = ({
  moduleId,
  widgetMoveUp,
  widgetMoveDown,
  widgetRemove,
  widgetAddColumn,
  widgetBoxClassName,
  section,
  zone,
  profileOwnerUser,
  showCoreUpsell,
  isCurrentUserCoreMember,
}) => {
  const { t } = useTranslation();

  const renderModal = close => {
    return (
      <Suspense fallback={<ChunkLoadingPopover />}>
        <BadgesSpotlightModal onClose={close} />
      </Suspense>
    );
  };

  return (
    <WidgetBox
      section={section}
      zone={zone}
      moduleId={moduleId}
      header={t('widgets.badgesSpotlight.title')}
      autoShowWidgetConfig
      widgetMenuRenderer={renderModal}
      widgetMoveUp={widgetMoveUp}
      widgetMoveDown={widgetMoveDown}
      widgetRemove={widgetRemove}
      widgetAddColumn={widgetAddColumn}
      className={widgetBoxClassName}
      seeAllUrl={Url.userLink(
        profileOwnerUser.username,
        `${USER_PROFILE_SECTION_PATHS.ABOUT}#badges_activity`
      )}
      editControlsTooltipContent={
        !isCurrentUserCoreMember && t('widgets.badgesSpotlight.edit.tooltip')
      }
    >
      <ConditionalWrapper
        condition={showCoreUpsell}
        wrap={child => (
          <WidgetPaywall
            title={t('widgets.badgesSpotlight.paywall.title')}
            subtitle={t('widgets.badgesSpotlight.paywall.subtitle')}
            buttonAlignment="horizontal"
            previewReferral={ReferralType.BADGES_SPOTLIGHT_PAYWALL_PREVIEW}
            lockedReferral={ReferralType.BADGES_SPOTLIGHT_PAYWALL_OVERLAY}
          >
            {child}
          </WidgetPaywall>
        )}
      >
        <BadgesSpotlight moduleId={moduleId} />
      </ConditionalWrapper>
    </WidgetBox>
  );
};
BadgesSpotlightBox.displayName = 'BadgesSpotlightBox';

export default BadgesSpotlightBox;
